/** Queued polite announcements (80 ms coalescing, never replacing a pending message) and toasts. */
import { ui, type ToastItem } from './state';

let pending: string[] = [];
let timer: ReturnType<typeof setTimeout> | null = null;

export function announce(msg: string | null | undefined): void {
  if (!msg) return;
  if (!pending.includes(msg)) pending.push(msg);
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    const el = document.getElementById('live');
    const text = pending.join(' ');
    pending = [];
    timer = null;
    if (!el) return;
    el.textContent = '';
    requestAnimationFrame(() => { el.textContent = text; });
  }, 80);
}

let nextId = 1;
export function toast(msg: string, { action, onAction, tone = '' }: { action?: string; onAction?: () => void; tone?: string } = {}): void {
  const t: ToastItem = { id: nextId++, msg, tone, ...(action ? { action } : {}), ...(onAction ? { onAction } : {}) };
  ui.toasts.push(t);
}
export function dismissToast(id: number): void {
  const i = ui.toasts.findIndex((t) => t.id === id);
  if (i >= 0) ui.toasts.splice(i, 1);
}
